<template>
  <div class="h-full flex flex-col p-4">
    <base-dialog :show="!!error" title="An error occurred!" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>
    <base-toast v-if="!!baseToast.message" :message="baseToast.message" :type="baseToast.type" @close="baseToast = { type: '', message: '' }"></base-toast>

    <section class="h-full flex flex-col">
      <base-card class="h-full flex flex-col">
        <div class="flex items-center justify-between px-4 py-3 border-b">
          <h2 class="text-lg font-semibold">Create Pay-In Order</h2>
          <button @click="$router.back()" class="text-gray-600 hover:text-gray-800">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <base-spinner v-if="isLoading" class="flex-auto"></base-spinner>
        <div v-else class="flex-auto overflow-y-auto p-6">
          <div class="max-w-2xl mx-auto">
            <!-- Amount -->
            <div class="mb-6">
              <label class="block text-sm font-medium text-gray-700 mb-2">Amount *</label>
              <input
                v-model.trim="amount.val"
                type="number"
                placeholder="Enter amount"
                @blur="clearValidity('amount')"
                @keypress="allowNumbersOnly"
                class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                :class="{ 'border-red-500': !amount.isValid }"
              />
              <p v-if="!amount.isValid" class="text-xs text-red-600 mt-1">{{ amount.msg }}</p>
            </div>

            <!-- Customer Name (Optional) -->
            <div class="mb-6">
              <label class="block text-sm font-medium text-gray-700 mb-2">Customer Name (Optional)</label>
              <input
                v-model.trim="customerName"
                type="text"
                placeholder="Enter customer name"
                class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
              />
            </div>

            <!-- Customer Mobile (Optional) -->
            <div class="mb-6">
              <label class="block text-sm font-medium text-gray-700 mb-2">Customer Mobile (Optional)</label>
              <input
                v-model.trim="customerMobile"
                type="text"
                placeholder="Enter customer mobile"
                class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
              />
            </div>

            <!-- Customer UPI ID (Optional) -->
            <div class="mb-6">
              <label class="block text-sm font-medium text-gray-700 mb-2">Customer UPI ID (Optional)</label>
              <input
                v-model.trim="customerUPIID"
                type="text"
                placeholder="Enter customer UPI ID"
                class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
              />
            </div>

            <!-- Action Buttons -->
            <div class="flex justify-end gap-3 mt-8">
              <button
                @click="$router.back()"
                class="px-6 py-2 border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white rounded-lg font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                @click="submitOrder"
                class="px-6 py-2 bg-green-600 text-white hover:bg-green-700 rounded-lg font-medium transition-colors"
              >
                Create Order
              </button>
            </div>
          </div>
        </div>
      </base-card>
    </section>
  </div>
</template>

<script>
import http from "../../http-common";

export default {
  name: "CreatePayInClient",
  data() {
    return {
      isLoading: false,
      error: null,
      baseToast: {
        type: "",
        message: "",
      },
      amount: {
        val: null,
        isValid: true,
        msg: "",
      },
      customerName: "",
      customerMobile: "",
      customerUPIID: "",
    };
  },
  computed: {
    vendor() {
      return this.$store.getters.vendor;
    },
  },
  methods: {
    allowNumbersOnly(event) {
      const charCode = event.which || event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    clearValidity(input) {
      this[input].isValid = true;
      this[input].msg = "";
    },
    validateForm() {
      let isValid = true;

      if (!this.amount.val || this.amount.val <= 0) {
        this.amount.isValid = false;
        this.amount.msg = "Amount must be greater than 0.";
        isValid = false;
      }

      return isValid;
    },
    async submitOrder() {
      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;

      const formData = {
        type: "payin",
        amount: parseInt(this.amount.val),
        customerName: this.customerName || undefined,
        customerMobile: this.customerMobile || undefined,
        customerUPIID: this.customerUPIID || undefined,
      };

      try {
        const response = await http.post(`/orders/${this.vendor}/createPayOutOrder`, formData);

        if (response.status === 201) {
          this.baseToast.type = "success";
          this.baseToast.message = response.data.message;

          setTimeout(() => {
            this.$router.push("/payin");
          }, 1500);
        }
      } catch (error) {
        this.error = error.response?.data?.message || "Failed to create order. Please try again.";
      }

      this.isLoading = false;
    },
    handleError() {
      this.error = null;
    },
  },
};
</script>
